import type * as Types from 'app/types/graphql';

import {
  PathAnalyticSelectFragmentDoc,
  PathAnalyticGroupSelectFragmentDoc,
  PathAnalyticPageSelectFragmentDoc,
  PathAnalyticMetricSelectFragmentDoc,
} from '../fragments/pathAnalytic.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type PathAnalyticsQueryVariables = Types.Exact<{
  input: Types.PathAnalyticInput;
}>;

export type PathAnalyticsQueryResponse = {
  pathAnalytics?: Types.Maybe<
    Array<
      Types.Maybe<{
        pathGroups?: Types.Maybe<
          Array<
            Types.Maybe<{
              paths?: Types.Maybe<
                Array<
                  Types.Maybe<
                    Pick<
                      Types.PathAnalytic,
                      | 'level'
                      | 'locationPath'
                      | 'id'
                      | 'parentID'
                      | 'pageType'
                      | 'shopifyPageID'
                      | 'pageTitle'
                    > & {
                      metric?: Types.Maybe<
                        Pick<
                          Types.PathAnalyticMetric,
                          | 'totalPageViewed'
                          | 'totalVisitors'
                          | 'totalClicked'
                          | 'totalAddedToCart'
                          | 'totalReachedCheckout'
                          | 'totalOrders'
                          | 'totalSessions'
                          | 'totalSessionsThatCompletedCheckout'
                          | 'totalSessionsThatReachedCheckout'
                          | 'totalSessionsWithCartAdditions'
                          | 'totalClickedHasHref'
                          | 'totalSessionsWithoutAction'
                          | 'totalContinuationSession'
                        >
                      >;
                    }
                  >
                >
              >;
            }>
          >
        >;
      }>
    >
  >;
};

export const PathAnalyticsDocument = `
    query PathAnalytics($input: PathAnalyticInput!) {
  pathAnalytics(input: $input) {
    ...PathAnalyticSelect
  }
}
    ${PathAnalyticSelectFragmentDoc}
${PathAnalyticGroupSelectFragmentDoc}
${PathAnalyticPageSelectFragmentDoc}
${PathAnalyticMetricSelectFragmentDoc}`;

export const usePathAnalyticsQuery = <TData = PathAnalyticsQueryResponse, TError = unknown>(
  variables: PathAnalyticsQueryVariables,
  options?: UseQueryOptions<PathAnalyticsQueryResponse, TError, TData>,
) => {
  return useQuery<PathAnalyticsQueryResponse, TError, TData>(
    ['PathAnalytics', variables],
    appFetcher<PathAnalyticsQueryResponse, PathAnalyticsQueryVariables>(
      PathAnalyticsDocument,
      variables,
    ),
    options,
  );
};

usePathAnalyticsQuery.getKey = (variables: PathAnalyticsQueryVariables) => [
  'PathAnalytics',
  variables,
];
